<template>
  <div class="text-xs-center">
    <v-dialog
      scrollable
      v-model="dialog"
      width="800">
      <v-card>
        <v-card-title primary-title>
          <v-layout wrap>
            <v-flex class="headline" sm6 xs12>
              Varianti più utilizzate
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="varianti"
            :loading="loading"
            hide-actions
          >
            <template v-slot:items="props">
              <td v-if="mostraCodiciArticolo">{{ props.item.cod_articolo }}</td>
              <td>
                {{ props.item.multi ? `[ ${props.item.gruppo} ]` : '' }}
                {{ props.item.descrizione }}
              </td>
              <td class="text-xs-right">{{ props.item.occorrenze }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import stats from '@/mixins/stats';

export default {
  name: 'row-detail',
  mixins: [stats],
  data: () => ({
    dialog: false,
    currentRow: null,
    varianti: [],
    loading: false,
  }),
  methods: {
    async show(row) {
      this.currentRow = row;
      this.varianti = [];
      this.dialog = true;
      this.loading = true;
      const varianti = await this.loadVariantiArticolo([row.locale, row.cod_articolo]);
      this.loading = false;
      if (varianti) {
        this.varianti = varianti.map(({
          cod_articolo: codArticolo,
          descrizione,
          occorrenze,
        }) => {
          const parts = descrizione.split('   ');
          const descr = parts.pop();
          parts.pop(); // toglie gruppo 'VARIANTI'
          const gruppo = parts
            .map(part => part.replace(/\[\w+\] /, ''))
            .join(' - ');
          return {
            cod_articolo: codArticolo,
            descrizione: descr,
            gruppo,
            occorrenze,
          };
        }).map(({ descrizione, ...parts }, _, arr) => ({
          ...parts,
          descrizione,
          multi: arr.filter(({ descrizione: d }) => d === descrizione).length > 1,
        }));
      }
    },
  },
  computed: {
    headers() {
      return [...(this.mostraCodiciArticolo ? [{
        text: 'Cod. articolo',
        value: 'cod_articolo',
        sortable: false,
      }] : []), {
        sortable: false,
        value: 'descrizione',
        text: 'Descrizione',
      }, {
        align: 'right',
        sortable: false,
        value: 'occorrenze',
        text: 'Occorrenze',
      }];
    },
  },
};
</script>

<style lang="stylus" scoped>
div >>> .v-card__text
  padding 0
</style>
